/* Ikimsoft scroll reveal - progressive enhancement only.
 *
 * SAFETY CONTRACT: nothing is hidden by this file alone. The class that sets
 * opacity:0 is added here, in JavaScript. If this script fails, is blocked, or
 * IntersectionObserver is missing, the element simply never gets the class and
 * renders exactly as it always did. A decorative animation must never be able
 * to take content off the page.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;                       // honour the preference first
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '.ik-hero__grid, .ik-about__grid, .ik-band--paper .ik-head, ' +
    '.ik-band--sand .ik-head, .ik-cta, .ik-grid > *'
  );
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('ik-is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  Array.prototype.forEach.call(targets, function (el, i) {
    /* stagger siblings so a grid cascades instead of popping as one block */
    el.style.transitionDelay = '';
    el.classList.add('ik-reveal');
    if (el.parentNode && el.parentNode.children.length > 1) {
      var n = Array.prototype.indexOf.call(el.parentNode.children, el);
      if (n > 0) el.style.animationDelay = (n * 70) + 'ms';
    }
    io.observe(el);
  });
})();
